import React from "react";
import { connect } from "react-redux";
import * as Redux from 'redux'
import {Container} from "react-bootstrap";
import BasicHeader from "../../common/header/basicHeader/BasicHeader";
import Footer from "../../common/footer/Footer";
import "./LoginPage.scss";
import "../../sass/main.scss";
import {
  getOtpOrLoginRequest,
  getResendOtpForLoginRequest,
  resetState,
  proceedLoginRequest,
} from "./LoginPageDucks";
import {LoginBody} from '../login/LoginBody';
import { replace } from "../../redux/navigation/navigationDucks";
import { resetDataEntryState} from '../../components/dataEntryDetails/DataEntryDetailsDucks';

interface LoginBodyProps {
  getOtpOrLoginRequest: Function;
  getOtpAPIStatus: number;
  getResendOtpForLoginRequest: Function;
  otp: string;
  resendOtp: string;
  redirectToLandingPage: Function,
  errorDescription: string,
  resetState: Function,
  resetDataEntryState: Function,
  accountActive: boolean,
  ssoEnabled: boolean,
  proceedLoginRequest: (email: string, onComplete?: (status: number, error?: string) => void) => void;
}
class LoginPage extends React.Component<LoginBodyProps> {
  componentDidMount(){
    this.props.resetDataEntryState && this.props.resetDataEntryState();
    this.props.resetState()
    sessionStorage.clear()
  }
  render() {
    return (
      <Container fluid className="app-container-custom-style">
        <BasicHeader />
        <LoginBody
          redirectToLandingPage={this.props.redirectToLandingPage}
          getOtpOrLoginRequest={this.props.getOtpOrLoginRequest}
          getOtpAPIStatus={this.props.getOtpAPIStatus}
          getResendOtpForLoginRequest={this.props.getResendOtpForLoginRequest}
          errorDescription= {this.props.errorDescription}
          resetDataEntryState={this.props.resetDataEntryState}
          proceedLoginRequest={this.props.proceedLoginRequest}
          accountActive={this.props.accountActive}
          ssoEnabled={this.props.ssoEnabled}
        />
        <Footer />
      </Container>
    );
  }
}
export function mapDispatchToProps(dispatch: Redux.Dispatch<Redux.Action>) {
  return {
    getOtpOrLoginRequest: (
      userName: string,
      otp?: string,
      onAPISuccess?: Function
    ) => dispatch(getOtpOrLoginRequest(userName, otp, onAPISuccess)),
    proceedLoginRequest: (
      email: string,
      onComplete?: (status: number, error?: string) => void
    ) => dispatch(proceedLoginRequest(email, onComplete)),
    getResendOtpForLoginRequest: (userName: string, otp?: string) =>
      dispatch(getResendOtpForLoginRequest(userName, otp)),
      redirectToLandingPage: () => dispatch(replace("/home")),
      resetState: () => dispatch(resetState()),
      resetDataEntryState: () => dispatch(resetDataEntryState())
  };
}
export function mapStateToProps(state: any) {
  return {
    getOtpAPIStatus: state.loginState.getOtpAPIStatus,
    accountActive: state.loginState.accountActive,
    ssoEnabled: state.loginState.ssoEnabled,
    errorDescription: state.loginState.errorDescription
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



